/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import { installDollarSignScrubber } from './utils/strip-dollar-sign.client';

if (ENV.SENTRY_DSN) {
  const { init } = await import('./utils/monitoring.client.ts');
  init({ sentryRelease: ENV.SENTRY_RELEASE });
}

async function prepareApp() {
  if (ENV.MOCK === 'true') {
    const { worker } = await import('mocks/browser');
    return worker.start({ onUnhandledRequest: 'bypass' });
  }

  return Promise.resolve();
}

await prepareApp();

// OCGC-3163: remove the stray "$" React's streaming reveal ($RC) writes into a reparented text
// node on prod. See ./utils/strip-dollar-sign.client.ts. Add the `?disableDollarSignScrubber=true`
// query param to the URL to switch the whole workaround off — e.g. when validating a React 19
// upgrade — to verify the issue is gone without it.
installDollarSignScrubber();

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
